import { connect } from 'react-redux';
import { AppState } from '../../redux/store';
import { devicesRequest } from '../../redux/actions/devices';
import { selectDeviceRequestStatus, selectDevices } from '../../redux/selectors/devices';
import { markPropertySoldRequest } from '../../redux/actions/properties';
import { selectMarkingAsSoldStatus } from '../../redux/selectors/properties';
import Devices from './Devices';
import { withStyles } from '@material-ui/core';
import styles from './styles';
import { getBuilderId } from '../../redux/selectors/auth';

const mapStateToProps = (state: AppState) => ({
  devices: selectDevices(state),
  loading: selectDeviceRequestStatus(state),
  markingAsSold: selectMarkingAsSoldStatus(state),
  builderId: getBuilderId(state),
});

const mapDispatchToProps = {
  loadDevices: devicesRequest,
  markPropertyAsSold: markPropertySoldRequest,
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Devices));
